export default "__VITE_ASSET__C3zN32vo__"